import { render, staticRenderFns } from "./AdminTop.vue?vue&type=template&id=63667719&"
import script from "./AdminTop.vue?vue&type=script&lang=js&"
export * from "./AdminTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports